<template>
    <div class="pro-item">
        <div class="title">
            按{{proName}}分类设置会员折扣<span v-if="isMain || !isUnified">（某些{{proName}}分类，打折不一样，请在此处设置）</span>
            <el-popover placement="right" width="600" trigger="click" popper-class="select-poper" v-model="selectCateState" v-if="isMain || !isUnified">
                <select-category @cancel="selectCateState = false" @done="addProCategoryDiscount" :selected-data="categoryIdList"
                                 :pro-type="proType"
                />
                <span class="text-btn" slot="reference">选择分类</span>
            </el-popover>
        </div>
        <div class="list-box">
            <el-table :data="categoryDisData.listData" style="width: 100%" @selection-change="handleCategorySelectionChange">
                <el-table-column
                        type="selection"
                        width="31"
                        v-if="isMain || !isUnified">
                </el-table-column>
                <el-table-column
                        v-for="(val, k) in categoryDisData.fields"
                        :prop="val.field"
                        :label="val.label">
                </el-table-column>

                <el-table-column label="操作" width="200" v-if="isMain || !isUnified">
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                @click="handleProEdit(scope.$index, scope.row)"
                        >编辑</el-button>
                        <el-button
                                size="mini"
                                type="danger"
                                @click="handleProDelete(scope.$index, scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page-box">
            <div class="tool" v-if="isMain || !isUnified">
                <el-button size="mini" @click="handleManyEdit">批量设置</el-button>
            </div>
            <div class="page">
                <el-pagination
                        @size-change="pageSizeChange"
                        @current-change="pageCurrentChange"
                        :current-page="page.nowPage"
                        :page-sizes="page.pageSizes"
                        :page-size="page.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="page.total">
                </el-pagination>
            </div>
        </div>

        <!--单个设置-->
        <edit-product-category-discount v-model="editBoxState" :pro-type="proType" :pro-data="editProData"
                                        @done="loadCategoryDisData"
        ></edit-product-category-discount>
        <!--批量设置-->
        <edit-many-discount v-model="editManyState" dis-type="2" :id-list="editManyCid" @done="loadCategoryDisData"
                            :pro-type="proType"
        />
    </div>
</template>

<script>
    import SelectCategory from "@/model/StoreUser/SelectCategory";
    import obj from "@/js/obj";
    import EditProductCategoryDiscount from "@/model/StoreUser/EditProductCategoryDiscount";
    import EditManyDiscount from "@/model/StoreUser/EditManyDiscount";
    export default {
        name: "ProductCategoryDiscount",
        components: {EditManyDiscount, EditProductCategoryDiscount, SelectCategory},
        props: {
            proType: {
                type: Number,
                default: 0
            }
        },
        data: () => ({
            proName: "",
            categoryDisData: [],        //分类优惠
            categoryIdList: [],         //分类ID集合
            selectCateState: false,
            page: {
                nowPage: 1,
                pageSize: 50,
                pageSizes: [50, 100, 200, 400],
                count: 0,
                v_num: 1,
                total: 0,
            },

            editBoxState: false,
            editProData: {},

            editManyState: false,
            editManyCid: [],
        }),
        computed: {
            isMain(){
                return this.$store.state.chain_option.is_main;
            },
            isUnified(){
                return this.$store.state.chain_option.is_unified_manage;
            }
        },
        mounted: function () {
            this.initData();
        },
        methods: {
            initData: function() {
                if(this.proType === 1) {
                    this.proName = "项目";
                }else if(this.proType === 2) {
                    this.proName = "产品";
                }else if(this.proType === 5) {
                    this.proName = "卡项";
                }else{
                    this.proName = "";
                    return false;
                }
                this.loadCategoryDisData();
            },
            //每页显示数量变化
            pageSizeChange: function (val) {
                this.page.pageSize = val;
                this.loadCategoryDisData();
            },

            //当前页码变化
            pageCurrentChange: function (val) {
                this.page.nowPage = val;
                this.loadCategoryDisData();
            },
            //获取项目分类优惠
            loadCategoryDisData: function () {
                let postData = {
                    pro_type: this.proType,
                    page: this.page.nowPage,
                    limit: this.page.pageSize * this.page.v_num,
                };
                obj.postData("store_vip/get_pro_category_discount", postData, res => {
                    //添加优惠单位
                    let fieldsArr = [];
                    res.data.fields.forEach( v => {
                        fieldsArr.push(v.field);
                    });

                    res.data.listData.forEach( v => {
                        let unit = v.discount_mode == 1 ? "折" : "元";
                        fieldsArr.forEach(key => {
                            if(obj.isEmpty(v[key]))
                                v[key] = "未设置";
                            else
                                v[key] += unit;
                        });
                    });

                    //添加第一列
                    res.data.fields.unshift({
                        label: "类别",
                        field: "c_name"
                    });

                    this.categoryDisData = {
                        fields: res.data.fields,
                        listData: res.data.listData
                    };

                    //分页数量
                    this.page.count = res.count ? res.count : 0;
                    this.page.v_num = res.v_num ? res.v_num : 1;
                    this.page.total = this.page.count / this.page.v_num;
                });
            },
            //选择的项目分类
            addProCategoryDiscount: function (cidArr) {
                this.selectCateState = false;
                if(obj.isEmpty(cidArr))
                    return false;

                obj.postData("store_vip/add_category_discount", {pro_type: this.proType, cid: cidArr.join(",")}, res => {
                    if(res.errcode === 0){
                        obj.message.success("添加成功");
                        this.loadCategoryDisData();
                    }else{
                        obj.message.error("添加失败");
                    }
                });
            },
            //选中指定分类项
            handleCategorySelectionChange: function (data) {
                let idArr = [];
                data.forEach( val => {
                    idArr.push(val.cid);
                });
                this.editManyCid = idArr;
            },
            //移除指定分类
            handleProDelete: function (index, data) {
                obj.postData("store_vip/delete_product_category", {cid: data.cid}, res => {
                    if(res.errcode === 0){
                        this.loadCategoryDisData();
                    }else{
                        obj.message.error("移除失败");
                    }
                });
            },
            //编辑按钮点击事件
            handleProEdit: function (index, data) {
                this.editProData = {
                    id: data.cid,
                    type: 2,
                    title: data.c_name,
                };
                this.editBoxState = true;
            },
            //批量设置
            handleManyEdit: function () {
                if(this.editManyCid.length < 1)
                    obj.message.error("请先选择要设置的类别");
                else
                    this.editManyState = true;
            }

        },
        watch: {
            proType: function () {
                this.initData();
            },
            categoryDisData: function (data) {
                //提取分类id
                let idList = [];
                data.listData.forEach((val, key) => {
                    idList.push(val.cid);
                });
                this.categoryIdList = idList;
            }
        }
    }
</script>

<style scoped>
    .pro-item>.title{
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        height: 16px;
        line-height: 16px;
        padding: 10px;
        min-width: 800px;
        overflow: hidden;
    }
    .pro-item>.title:before{
        width: 4px;
        height: 16px;
        background-color: #0f9cf3;
        border-radius: 2px;
        content: "";
        display: inline-block;
        margin-right: 10px;
        vertical-align: text-top;
    }
    .text-btn {
        font-size: 14px;
        color: #6cb1e1;
        margin-left: 10px;
        cursor: pointer;
    }
    .page-box{
        border-top: none;
    }
    .page-box .tool{
        width: 300px;
        float: left;
    }
    .el-pagination{
        text-align: right;
    }
</style>

<style>
    .select-poper{
        padding: 0;
    }
</style>
